import * as React from "react";
import { IconCircle } from "@lib/components";
import { FaCheck, FaTimes } from "react-icons/fa";

export const SettingsSuccessIndicator = (props: { background?: string }) => <IconCircle size={16} className={"m-r-2"} icon={<FaCheck />} iconSizeModifier={6} background={props.background || "complete"} />;
export const SettingsInactiveIndicator = (props: { background?: string }) => <IconCircle size={16} className={"m-r-2"} icon={<FaTimes />} iconSizeModifier={6} background={props.background || "grey"} />;
